/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import throttle from 'lodash.throttle';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Link from 'components/Link';
import { inViewForReact } from 'utils/common';
// import AdCaller from '../../../helpers/ads/adCaller';
import s from './IPLWidget.scss';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import FlipCardAd from '../../common/FlipCardAd';

class IPLWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      data: {},
    };

    this.ref = React.createRef();
    this.iplRef = React.createRef();

    this.autoRefreshStarted = false;
  }

  componentDidMount() {
    const { dataUrl } = this.props;
    if (dataUrl) {
      this.getMatchesData(true);
      this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
      window.addEventListener('scroll', this.throttledGAonScroll);

      if (this.props.autoRefresh) {
        this.refreshTimer = setInterval(
          this.getMatchesData,
          this.props.autoRefreshRate || 15000,
        );
      }
    }
  }

  removeScrollEvent = () => {
    if (typeof this.throttledGAonScroll === 'function') {
      window.removeEventListener('scroll', this.throttledGAonScroll);
    }
  };

  handleGAOnScroll = () => {
    const liveMatches = this.getLiveMatch();
    const { isLiveScoreWidget } = this.props;
    if (
      this.iplRef &&
      this.iplRef.current &&
      inViewForReact(this.iplRef.current, 0, true) &&
      (!isLiveScoreWidget ||
        (isLiveScoreWidget && liveMatches && liveMatches.length))
    ) {
      if (isLiveScoreWidget) {
        const gaData = {
          gaCategory: 'WAP-IN-NHP1',
          gaAction: isLiveScoreWidget
            ? 'IPLlive_Widget_Seen'
            : 'scroll_measure',
          gaLabel: isLiveScoreWidget
            ? window.location.href
            : 'Scroll_IPL_WidgetEnds',
        };
        this.sendGA(gaData);
      }
      this.removeScrollEvent();
    }
  };

  componentWillUnmount() {
    if (this.timeoutVal) {
      clearTimeout(this.timeoutVal);
    }
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    this.removeScrollEvent();
  }

  refreshData = autoUpadteTime => {
    if (autoUpadteTime) {
      this.timeoutVal = setTimeout(() => {
        this.getMatchesData();
        this.refreshData(autoUpadteTime);
      }, autoUpadteTime);
    }
  };

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };

  getAndSetLiveMatchInView = () => {
    if (this.ref && this.ref.current) {
      try {
        const elem = this.ref.current.querySelector(`[data-matchindex="1"]`);
        if (elem) {
          const boundingData = elem.getBoundingClientRect();
          this.ref.current.scrollLeft =
            this.ref.current.scrollLeft + boundingData.left - 10;
        }
      } catch (e) {
        // console.log(e);
      }
    }
  };

  getMatchesData = (setLiveMatchInView, evt) => {
    if (evt && evt.target && evt.stopPropagation && evt.preventDefault) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    this.setState({
      refreshing: true,
    });

    setTimeout(() => {
      this.setState({
        refreshing: false,
      });
    }, 1000);

    const { dataUrl } = this.props;
    makeRequest.get(dataUrl).then(response => {
      const { data } = response;
      this.setState({ data });
      if (data && data.matches) {
        const liveMatch = data.matches.find(match => match.status === 'live');
        if (liveMatch) {
          liveMatch.default = 'true';
        }
        this.setState(
          {
            data,
          },
          () => {
            if (setLiveMatchInView && data && data.matches) {
              this.getAndSetLiveMatchInView();
            }
            if (typeof this.props.showMiniScoreCard === 'function') {
              const eventName =
                data.matches &&
                data.matches instanceof Array &&
                data.matches[0] &&
                data.matches[0].event
                  ? data.matches[0].event
                  : '';
              this.props.showMiniScoreCard(true, eventName);
            }
          },
        );

        if (
          data.autoUpadteTime &&
          // eslint-disable-next-line no-restricted-globals
          !isNaN(data.autoUpadteTime) &&
          !this.autoRefreshStarted
        ) {
          this.autoRefreshStarted = true;
          this.refreshData(parseInt(data.autoUpadteTime, 10));
        }
      }
    });
  };

  getRefreshButton = () => (
    <button
      type="button"
      className={`${s.refreshBtn} ${this.state.refreshing ? s.active : ''}`}
      onClick={e => this.getMatchesData(false, e)}
    />
  );

  getMatchCard = match => {
    const { team1, team2 } = match;
    const { isLiveScoreWidget } = this.props;
    const liveMatch = this.getLiveMatch();
    const gaData = {
      gaCategory: this.props.gaCategory || 'WAP-IN-NHP1',
      gaAction: this.props.gaAction || 'IPL_Widget_Actions',
      gaLabel: this.props.gaLabel || 'click_score',
    };
    if (isLiveScoreWidget) {
      const urlParams = new URL(window.location.href);
      gaData.gaAction = 'IPLlive_Widget_Clicked';
      gaData.gaLabel =
        liveMatch &&
        Array.isArray(liveMatch) &&
        liveMatch.length &&
        liveMatch[0].scorecardLink
          ? `${urlParams?.origin}${liveMatch[0].scorecardLink}`
          : '';
    }

    const html = (
      <React.Fragment>
        <div
          className={`${s.flexbox} ${s.matchInfo} matchCardWrapper`}
          data-matchindex={match.default === 'true' ? '1' : '-1'}
        >
          <h3>{team1.name}</h3>
          <span>
            {(match.status === 'live' || match.status === 'Super over') && (
              <strong className={`${s.status} ${s.live}`}>LIVE</strong>
            )}
            {match.matchNo} - {match.matchDate}
          </span>
          <h3>{team2.name}</h3>
        </div>
        <div className={`${s.flexbox} ${s.teamInfo}`}>
          <div className={`${s.flexbox} ${s.teamname} ${s.left}`}>
            <i className={`${s.icon} ${s[team1.name]}`} />
            <div
              className={`${s.scoreInfo} ${
                match.status && match.status.toLowerCase() === 'match ended'
                  ? s.matchend
                  : ''
              }`}
            >
              <h2
                className={
                  team1.highlight &&
                  team1.highlight.toLowerCase() === 'yes' &&
                  match.status &&
                  (match.status.toLowerCase() === 'live' ||
                    match.status.toLowerCase() === 'super over')
                    ? s.highlight
                    : ''
                }
              >
                {team1.score && team1.score.text1 ? team1.score.text1 : ''}
              </h2>
              <p>{team1.score && team1.score.text2 ? team1.score.text2 : ''}</p>
            </div>
          </div>
          <div>
            {match.status === 'live' && !this.props.cardsLinkout ? (
              this.getRefreshButton()
            ) : (
              <span
                className={`${s.status} ${s[match.status]}`}
                title={match.status}
              >
                {(match.status &&
                  match.status.toLowerCase() === 'match yet to start') ||
                match.status.toLowerCase() === 'match yet to begin'
                  ? 'Yet to start'
                  : match.status}
              </span>
            )}
            <div className={`${s.superovercount} superovercount`}>
              {team1.score && team1.score.text3
                ? team1.score.text3
                : team2.score && team2.score.text3 ? team2.score.text3 : ''}
            </div>
          </div>
          <div className={`${s.flexbox} ${s.teamname} ${s.right}`}>
            <div
              className={`${s.scoreInfo} ${
                match.status === 'Match Ended' ? s.matchend : ''
              }`}
            >
              <h2
                className={
                  team2.highlight &&
                  team2.highlight.toLowerCase() === 'yes' &&
                  match.status &&
                  (match.status.toLowerCase() === 'live' ||
                    match.status.toLowerCase() === 'super over')
                    ? s.highlight
                    : ''
                }
              >
                {team2.score && team2.score.text1 ? team2.score.text1 : ''}
              </h2>
              <p>{team2.score && team2.score.text2 ? team2.score.text2 : ''}</p>
            </div>
            {/* <Link to={team2.profileLink} target="_blank">
              <i className={`${s.icon} ${s[team2.name]}`} />
            </Link> */}
            <i className={`${s.icon} ${s[team2.name]}`} />
          </div>
        </div>
        <p
          className={`${s.matchStatus} ${s[match.status]}`}
          title={match.summary ? match.summary : ''}
        >
          {match.status === 'upcoming'
            ? match.matchtime !== ''
              ? `${match.matchtime}, ${match.venue}`
              : `${match.venue}`
            : match.summary}
          {isLiveScoreWidget &&
          liveMatch &&
          Array.isArray(liveMatch) &&
          liveMatch.length ? (
            <div className={s.scoreBoardLink}>
              <Link
                to={
                  liveMatch &&
                  Array.isArray(liveMatch) &&
                  liveMatch.length &&
                  liveMatch[0].scorecardLink
                    ? liveMatch[0].scorecardLink
                    : ''
                }
                className={s.liveMatchScoreLink}
                data-ga={this.props.gaData}
              >
                Full Scorecard
              </Link>
            </div>
          ) : (
            ''
          )}
        </p>
        {/* {!this.props.cardsLinkout &&
          match.scorecardLink && (
            <div className={s.btnGrp}>
              <a href={match.scorecardLink} className={s.btn}>
                Full Scorecard
              </a>
            </div>
          )} */}
      </React.Fragment>
    );

    return (
      <React.Fragment>
        {!this.props.isLiveIccIplWpl &&
        ((match.status === 'live' &&
          this.props.cardsLinkout &&
          match.scorecardLink) ||
          ((match.status !== 'upcoming' && match.status !== 'live') ||
            match.status === 'upcoming' ||
            (isLiveScoreWidget && match.status === 'live'))) ? (
          <Link to={match.scorecardLink} className={s.content} data={gaData}>
            {html}
          </Link>
        ) : (
          <div className={s.content}>{html}</div>
        )}
      </React.Fragment>
    );
  };

  getLiveMatch = () => {
    const { data } = this.state;
    const { matches } = data;
    const liveMatches = (matches || []).filter(
      match => match && match.status && match.status === 'live',
    );
    if (liveMatches && Array.isArray(liveMatches) && liveMatches.length > 1) {
      return liveMatches.slice(0, 1);
    }
    return liveMatches;
  };

  render() {
    // if (
    //   !(
    //     this.state.data &&
    //     this.state.data.matches &&
    //     this.state.data.matches.length > 0
    //   )
    // ) {
    //   return null;
    // }

    const { data } = this.state;
    const { matches, footerData } = data;
    const {
      isLiveScoreWidget,
      isIPLHomePageWidget,
      // isLiveIccIplWpl,
    } = this.props;
    const liveMatch = this.getLiveMatch();
    return (
      <InViewObserver
        inViewCallback={() => {
          if (this.props.gaViewData) {
            analyticsWrapper('ga', 'send', 'event', ...this.props.gaViewData);
          }
        }}
        className="border_none"
      >
        <div
          className={`${s.iplwidget} ${
            isIPLHomePageWidget ? '' : s.olympic_widget_hp
          } ${s.scorecard_v2} ${isLiveScoreWidget ? s.scoreCardSingle : ''} ${
            isIPLHomePageWidget ? s.iplHomePageWidget : ''
          }`}
          ref={this.iplRef}
        >
          {(isLiveScoreWidget || isIPLHomePageWidget) &&
            (data.title ? (
              <h2>
                <Link
                  to={data.url || '/sports/cricket/ipl'}
                  data={{
                    gaCategory: 'WAP-IN-NHP1',
                    gaAction: 'IPL_Widget_Actions',
                    gaLabel: `click_lp`,
                  }}
                >
                  {data.title}
                </Link>
              </h2>
            ) : null)}
          {/* Score card Sponser Ad wrap */}
          {/* {isLiveScoreWidget &&
            Array.isArray(liveMatch) &&
            !!liveMatch.length &&
            isLiveIccIplWpl && (
              <div className={s.adHeader}>
                <div className={s.sponserLogo}>
                  {this.state?.data?.ad && (
                    <AdCaller data={this.state?.data?.ad} />
                  )}
                </div>
                <div className={s.poweredBy}>
                  <span className={s.scoreText}>LIVE SCORE</span>
                  <span className={s.poweredByText}>POWERED BY</span>
                </div>
              </div>
            )} */}
          <div
            ref={this.ref}
            className={`${s.widget} ${s.liveScorecard} ${
              this.props.theme ? s[this.props.theme] : ''
            }`}
          >
            {isLiveScoreWidget
              ? liveMatch &&
                liveMatch.map(match => (
                  <React.Fragment key={match.matchNo}>
                    {isIPLHomePageWidget ? (
                      this.getMatchCard(match)
                    ) : (
                      <FlipCardAd
                        height="148px"
                        uid={match.matchNo}
                        isFlipActive
                        msid={this.props.msid}
                      >
                        {this.getMatchCard(match)}
                      </FlipCardAd>
                    )}
                  </React.Fragment>
                ))
              : matches &&
                matches.map(match => (
                  <React.Fragment key={match.matchNo}>
                    {isIPLHomePageWidget ? (
                      this.getMatchCard(match)
                    ) : (
                      <FlipCardAd
                        height="148px"
                        uid={match.matchNo}
                        isFlipActive
                      >
                        {this.getMatchCard(match)}
                      </FlipCardAd>
                    )}
                  </React.Fragment>
                ))}

            {/* {matches.map(match => (
            <React.Fragment key={match.matchNo}>
              {this.getMatchCard(match)}
            </React.Fragment>
          ))} */}
          </div>

          {footerData &&
            !isLiveScoreWidget &&
            footerData.length > 0 && (
              <div className={s.ipllinks}>
                {footerData.map(val => (
                  <Link
                    key={val.name}
                    to={val.url}
                    className={s[val.icon]}
                    data={{
                      gaCategory: 'WAP-IN-NHP1',
                      gaAction: 'IPL_Widget_Actions',
                      gaLabel: `${val.gaLabel || ''}`,
                    }}
                  >
                    {val.name}
                  </Link>
                ))}
              </div>
            )}
        </div>
      </InViewObserver>
    );
  }
}

IPLWidget.propTypes = {
  theme: PropTypes.string,
  sponsorAd: PropTypes.shape({}),
  autoRefresh: PropTypes.bool,
  autoRefreshRate: PropTypes.number,
  // setFallback: PropTypes.func,
  showMiniScoreCard: PropTypes.func,
  dataUrl: PropTypes.string.isRequired,
  cardsLinkout: PropTypes.bool,
  isLiveScoreWidget: PropTypes.bool,
  isLiveIccIplWpl: PropTypes.bool,
  isIPLHomePageWidget: PropTypes.bool,
};

IPLWidget.defaultProps = {
  theme: '',
  sponsorAd: undefined,
  showMiniScoreCard: undefined,
  cardsLinkout: false,
  autoRefresh: false,
  autoRefreshRate: undefined,
  isLiveScoreWidget: false,
  isIPLHomePageWidget: false,
  isLiveIccIplWpl: false,
  // setFallback: () => {},
};

export default IPLWidget;
